import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import { JSONSchema7 } from 'json-schema';
import { SessionItemData } from 'src/app/workflow/services/session-item-data';
import { JSONSchema7Extensions } from '@interfaces/interfaces';


@Component({
	selector: 'workflow-string-renderer',
	templateUrl: './string-renderer.component.html',
	styleUrls: ['./string-renderer.component.less']
})
export class StringRendererComponent implements OnChanges {

	@Input() schema: JSONSchema7 & JSONSchema7Extensions;

	@Input() data: SessionItemData;

	@Input() property: string[];

	@Input() required: boolean;

	format = 'text';

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.schema) {
			if (this.schema?.$renderhint) {
				this.format = this.schema.$renderhint;
			} else {
				this.format = this.schema?.format || 'text';
			}
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	get value(): any {
		return this.data.getProperty(this.property);
	}

	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
	set value(value: any) {
		this.data.setProperty(this.property, value);
	}

}
